import React, { useContext, useState } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import CustomSelect from '@components/Gui/NwForm/CustomSelect';
import FilterClearButton from '@components/Gui/NwForm/FilterClearButton';
import NwSegmented from '@components/Gui/NwForm/NwSegmented';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
`;

const LegalStatusFilter = ({ onChange, value }) => {
    //const [controlValue, setControlValue] = useState(value);

    const { cachedList } = useContext(ListContext);
    const legalTypes = cachedList.legalTypes.items;
    const documentTypeOptions = [
        { value: null, label: 'Select a document type' },
        ...legalTypes.filter((x) => !x.YearlyRequired).map((type) => ({ value: type.Code, label: type.Name })),
    ];

    const handleChangeType = (selectedValue) => {
        if (!selectedValue) {
            onChange([null, null]);
        } else {
            onChange([selectedValue, value[1]]);
        }
    };

    const handleChangeStatus = (selectedValue) => {
        onChange([value[0], selectedValue]);
    };

    const clearFilter = () => {
        onChange([null, null]);
    };

    return (
        <Wrapper>
            <CustomSelect value={value[0]} onChange={handleChangeType} options={documentTypeOptions} />
            <NwSegmented
                value={value[1]}
                disabled={!value[0]}
                options={[
                    { label: 'All', value: null },
                    { label: 'Expired', value: true },
                    { label: 'Valid', value: false },
                ]}
                onChange={handleChangeStatus}
            />
            <FilterClearButton onClick={clearFilter} />
        </Wrapper>
    );
};

export default LegalStatusFilter;
